/**
 * The one rule for which call-to-action buttons a fan can see.
 *
 * Shared by the fan page (TagPage) and the club portal's live preview so the
 * two never disagree: the club-level switch (club_settings.cta_enabled) must
 * be on, and a button shows only when the club enabled it AND it has
 * somewhere to go. A freshly added "New Button" with no link is invisible to
 * fans, so it must be invisible in the preview too. A missing switch counts
 * as on, matching the column default.
 */
export function visibleCtaButtons<T extends { enabled: boolean; button_url: string | null }>(
  buttons: readonly T[],
  featureEnabled: boolean | null | undefined = true,
): T[] {
  if (featureEnabled === false) return [];
  return buttons.filter((b) => b.enabled && !!b.button_url?.trim());
}
